import { render } from "./FeedbackModal.vue?vue&type=template&id=0a122b60&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"

import "./FeedbackModal.vue?vue&type=style&index=0&id=0a122b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a122b60"]])

export default __exports__